import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React from 'react';
import { t } from '../../../../types/translation/Translator';
import { Button } from '../../../components/Button';
import { ButtonVariant } from '../../../components/Button/Button';
import { Modal, ModalContentText, ModalSubtitle, ModalTitle } from '../../../components/Modal';

interface OnboardingAbortModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onAbort: () => void;
}

export default function OnboardingAbortModal({ open, setOpen, onAbort }: OnboardingAbortModalProps) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className='px-8 py-4'>
        <ModalTitle text={'Existing Onboarding'} className='mb-2' />
        <ModalSubtitle text={'Are you sure you want to leave the onboarding now?'} className='mb-1' />
        <ModalContentText text={'Your progress will NOT be saved!'} className='mb-4' />
        <div className='flex justify-end gap-2'>
          <Button
            variant={ButtonVariant.link}
            onClick={() => setOpen(false)}
            text={t(TranslationKey.cancel).singular.label}
          />
          <Button variant={ButtonVariant.danger} onClick={onAbort} text={'Leave onboarding'} />
        </div>
      </div>
    </Modal>
  );
}
